/**
 * RETOBLOCK STARTUP WELCOME & PROJECT SETUP LAUNCHER
 * Cửa sổ khởi động và quản lý dự án:
 * - Bước 1: Màn hình Chào mừng với 2 lựa chọn "Tạo dự án mới" và "Mở dự án"
 * - Bước 2: Cấu hình Dự án Mới (Chọn Kit: RETOLOGIX Basic, Ngôn ngữ: Scratch/Python, Đặt tên)
 */

export class SetupWizard {
  constructor(options) {
    this.container = options.container;
    this.onCreateProject = options.onCreateProject;
    this.onOpenProject = options.onOpenProject;

    this.currentStep = 'welcome'; // 'welcome' | 'new_project'
    this.isFirstLaunch = true;
    this.selectedKit = 'RETOLOGIX-BASIC';
    this.selectedLanguage = 'scratch';
    this.projectName = 'Du_An_Robot_1';

    this.init();
  }

  init() {
    this.render();
  }

  render() {
    if (this.currentStep === 'welcome') {
      this.renderWelcomeView();
    } else {
      this.renderNewProjectView();
    }
  }

  renderWelcomeView() {
    const closeBtnHtml = !this.isFirstLaunch
      ? `<button class="btn-close-modal" id="btn-close-wizard" title="Đóng">&times;</button>`
      : '';

    this.container.innerHTML = `
      <div class="modal-overlay active" id="wizard-overlay">
        <div class="modal-card launcher-welcome-modal">
          <div class="launcher-header">
            <div class="launcher-brand">
              <img src="/assets/logo-retocode.png" alt="RETOCODE" class="launcher-logo-img" />
            </div>
            ${closeBtnHtml}
          </div>

          <div class="launcher-body">
            <div class="launcher-welcome-banner">
              <h2 class="launcher-heading">Chào mừng bạn đến với RETOCODE Studio</h2>
              <p class="launcher-subheading">
                Môi trường lập trình kép thông minh và trực quan cho các bộ Kit Robot STEAM.
                Hãy chọn một phương thức để bắt đầu học tập và sáng tạo:
              </p>
            </div>

            <!-- 2 LỰA CHỌN CHÍNH: TẠO DỰ ÁN MỚI & MỞ DỰ ÁN -->
            <div class="launcher-choices-grid">
              <!-- Lựa chọn 1: Tạo dự án mới -->
              <div class="launcher-choice-card new-project" id="btn-choice-new-project" role="button" tabindex="0">
                <div class="choice-icon-box new-project">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="8" x2="12" y2="16"></line>
                    <line x1="8" y1="12" x2="16" y2="12"></line>
                  </svg>
                </div>
                <div class="choice-content">
                  <h3 class="choice-title">Tạo Dự Án Mới</h3>
                  <p class="choice-desc">
                    Khởi tạo dự án từ đầu, lựa chọn bộ Kit robot, ngôn ngữ lập trình Scratch hoặc Python.
                  </p>
                </div>
                <div class="choice-action-btn">
                  <span>Bắt đầu tạo dự án</span>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                  </svg>
                </div>
              </div>

              <!-- Lựa chọn 2: Mở dự án từ máy tính -->
              <div class="launcher-choice-card open-project" id="btn-choice-open-project" role="button" tabindex="0">
                <div class="choice-icon-box open-project">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>
                    <polyline points="12 11 12 17"></polyline>
                    <polyline points="9 14 12 11 15 14"></polyline>
                  </svg>
                </div>
                <div class="choice-content">
                  <h3 class="choice-title">Mở Dự Án (.reto)</h3>
                  <p class="choice-desc">
                    Mở tệp dự án định dạng <strong>.reto</strong> đã lưu trên máy tính để tiếp tục lập trình.
                  </p>
                </div>
                <div class="choice-action-btn">
                  <span>Chọn tệp từ máy tính</span>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Hidden file input for opening .reto files directly -->
      <input type="file" id="wizard-file-input" accept=".reto,.zip" style="display: none;" />
    `;

    this.bindWelcomeEvents();
  }

  renderNewProjectView() {
    const closeBtnHtml = !this.isFirstLaunch
      ? `<button class="btn-close-modal" id="btn-close-wizard" title="Đóng">&times;</button>`
      : '';

    this.container.innerHTML = `
      <div class="modal-overlay active" id="wizard-overlay">
        <div class="modal-card wizard-modal">
          <div class="modal-header">
            <div class="modal-title-group">
              <button class="btn-modal-back" id="btn-back-to-welcome" title="Quay lại màn hình lựa chọn">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <line x1="19" y1="12" x2="5" y2="12"></line>
                  <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                <span>Quay lại</span>
              </button>
              <div class="modal-title">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--color-primary)" stroke-width="2"><path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
                <span>KHỞI TẠO DỰ ÁN MỚI</span>
              </div>
            </div>
            ${closeBtnHtml}
          </div>

          <div class="modal-body">
            <!-- Bước 1: Chọn Thiết Bị Mục Tiêu (Kit) -->
            <div class="wizard-step">
              <div class="step-label">Bước 1: Chọn Bộ Kit Robot</div>
              <div class="kit-cards-grid">
                <!-- Bộ Kit duy nhất hiện tại: RETOLOGIX Basic -->
                <div class="kit-card selected" id="card-kit-retologix-basic">
                  <div class="kit-image-wrapper">
                    <img src="/assets/retocar_starter.jpg" alt="Robot RETOLOGIX Basic ESP32" onerror="this.src='/assets/retocar_starter_3d_1790006040657.jpg'" />
                  </div>
                  <div class="kit-info-header">
                    <div class="kit-title">RETOLOGIX Basic</div>
                  </div>          
                </div>
              </div>
            </div>

            <!-- Bước 2: Chọn Ngôn Ngữ -->
            <div class="wizard-step">
              <div class="step-label">Bước 2: Chọn Ngôn Ngữ Lập Trình</div>
              <div class="lang-cards-grid">
                <!-- Scratch -->
                <div class="lang-card ${this.selectedLanguage === 'scratch' ? 'selected' : ''}" id="card-lang-scratch">
                  <div class="lang-icon-box scratch">🧩</div>
                  <div class="lang-text-group">
                    <div class="lang-info-title">SCRATCH BLOCKS</div>
                    <div class="lang-info-desc">Kéo thả khối lệnh trực quan chuẩn Scratch 3.0.</div>
                  </div>
                  <div class="lang-check-indicator">✓</div>
                </div>

                <!-- Python -->
                <div class="lang-card ${this.selectedLanguage === 'python' ? 'selected' : ''}" id="card-lang-python">
                  <div class="lang-icon-box python">🐍</div>
                  <div class="lang-text-group">
                    <div class="lang-info-title">PYTHON CODE</div>
                    <div class="lang-info-desc">Soạn thảo mã nguồn Python.</div>
                  </div>
                  <div class="lang-check-indicator">✓</div>
                </div>
              </div>
              <div class="lang-warning-note">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" x2="12.01" y1="16" y2="16"/></svg>
                <span>Ngôn ngữ được cố định cho dự án này và không thể chuyển đổi sau khi tạo để tránh xung đột logic.</span>
              </div>
            </div>

            <!-- Bước 3: Đặt Tên Dự Án -->
            <div class="wizard-step">
              <div class="step-label">Bước 3: Đặt Tên Dự Án</div>
              <div class="project-input-group">
                <input type="text" class="project-name-textfield" id="input-wizard-name" value="${this.projectName}" placeholder="Nhập tên dự án (VD: Xe_Do_Line_Giao_Hang)" maxlength="40" />
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button class="btn-secondary-modal" id="btn-cancel-wizard">
              ${this.isFirstLaunch ? 'Quay lại' : 'Hủy'}
            </button>
            <button class="btn-primary-modal" id="btn-submit-wizard">
              <span>Bắt Đầu Lập Trình</span>
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                <polygon points="5 3 19 12 5 21 5 3"></polygon>
              </svg>
            </button>
          </div>
        </div>
      </div>
    `;

    this.bindNewProjectEvents();
  }

  bindWelcomeEvents() {
    const btnNew = document.getElementById('btn-choice-new-project');
    const btnOpen = document.getElementById('btn-choice-open-project');
    const fileInput = document.getElementById('wizard-file-input');
    const closeBtn = document.getElementById('btn-close-wizard');

    if (btnNew) {
      btnNew.addEventListener('click', () => {
        this.currentStep = 'new_project';
        this.render();
      });
    }

    if (btnOpen && fileInput) {
      btnOpen.addEventListener('click', () => {
        fileInput.click();
      });

      fileInput.addEventListener('change', (e) => {
        const file = e.target.files && e.target.files[0];
        if (file && this.onOpenProject) {
          this.hide();
          this.isFirstLaunch = false;
          this.onOpenProject(file);
        }
        e.target.value = '';
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.hide());
    }
  }

  bindNewProjectEvents() {
    const backBtn = document.getElementById('btn-back-to-welcome');
    const cancelBtn = document.getElementById('btn-cancel-wizard');
    const closeBtn = document.getElementById('btn-close-wizard');
    const submitBtn = document.getElementById('btn-submit-wizard');
    const nameInput = document.getElementById('input-wizard-name');

    const cardScratch = document.getElementById('card-lang-scratch');
    const cardPython = document.getElementById('card-lang-python');

    if (backBtn) {
      backBtn.addEventListener('click', () => {
        this.currentStep = 'welcome';
        this.render();
      });
    }

    if (cancelBtn) {
      cancelBtn.addEventListener('click', () => {
        if (this.isFirstLaunch) {
          this.currentStep = 'welcome';
          this.render();
        } else {
          this.hide();
        }
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', () => this.hide());
    }

    if (cardScratch && cardPython) {
      cardScratch.addEventListener('click', () => {
        this.selectedLanguage = 'scratch';
        cardScratch.classList.add('selected');
        cardPython.classList.remove('selected');
      });

      cardPython.addEventListener('click', () => {
        this.selectedLanguage = 'python';
        cardPython.classList.add('selected');
        cardScratch.classList.remove('selected');
      });
    }

    if (submitBtn && nameInput) {
      submitBtn.addEventListener('click', () => {
        let name = nameInput.value.trim();
        if (!name) name = 'Du_An_Robot_1';
        this.projectName = name;
        this.hide();
        this.isFirstLaunch = false;

        if (this.onCreateProject) {
          this.onCreateProject({
            name,
            languageMode: this.selectedLanguage,
            targetKit: this.selectedKit
          });
        }
      });
    }
  }

  show(options = {}) {
    this.currentStep = options.initialStep || (this.isFirstLaunch ? 'welcome' : 'new_project');
    if (typeof options.isFirstLaunch === 'boolean') {
      this.isFirstLaunch = options.isFirstLaunch;
    }
    this.projectName = `Du_An_Robot_${Math.floor(Math.random() * 90 + 10)}`;
    this.render();
  }

  hide() {
    const overlay = document.getElementById('wizard-overlay');
    if (overlay) {
      overlay.classList.remove('active');
    }
  }
}
